/**
 * Created by strunz on 11.05.2017.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'showAble',
    pure: false
})
export class ShowAblePipe implements PipeTransform {
    transform(items: Array<any>): Array<any> {
        return items.filter(item => item.showAble);
    }
}